// AUTO-GENERATED (gen_henprofit_i18n.py). Poultry-house profitability calculator, 22 languages.
export const HENPROFIT_GEN = {
 "fr": {
  "slug": "calculateur-rentabilite-poulailler",
  "title": "Calculateur de rentabilité d'un poulailler | Ma Petite Ferme",
  "metaDescription": "Calculez gratuitement la rentabilité de votre poulailler : revenus, coûts et bénéfice mensuel selon le nombre de poules, la ponte et le prix des œufs.",
  "h1": "Calculateur de rentabilité d'un poulailler",
  "intro": "Estimez le bénéfice de votre poulailler en quelques secondes. Ajustez le nombre de poules, le taux de ponte, le prix de vente et vos coûts pour connaître votre rentabilité mensuelle et annuelle.",
  "hens": "Nombre de poules pondeuses",
  "layRate": "Taux de ponte (%)",
  "eggPrice": "Prix de vente d'un œuf (€)",
  "feedPerHen": "Consommation par poule (g/jour)",
  "feedPrice": "Prix de l'aliment (€/kg)",
  "otherMonthly": "Autres coûts mensuels (€)",
  "resultTitle": "Rentabilité estimée",
  "revenue": "Revenu mensuel",
  "cost": "Coût mensuel",
  "profit": "Bénéfice mensuel",
  "profitYear": "Bénéfice annuel",
  "margin": "Marge",
  "disclaimer": "Estimation indicative basée sur vos saisies. N'inclut pas l'amortissement du matériel ni la main-d'œuvre.",
  "ctaTitle": "Suivez votre rentabilité réelle avec Ma Petite Ferme",
  "ctaText": "Enregistrez vos pontes, vos coûts et vos ventes pour piloter la rentabilité de votre poulailler au quotidien.",
  "ctaBtn": "Créer ma ferme gratuitement"
 },
 "en": {
  "slug": "chicken-coop-profitability-calculator",
  "title": "Chicken Coop Profitability Calculator | Ma Petite Ferme",
  "metaDescription": "Free chicken coop profitability calculator: estimate your monthly revenue, feed costs and egg sales profit based on flock size and laying rate.",
  "h1": "Chicken Coop Profitability Calculator",
  "intro": "Estimate your chicken coop profit in seconds. Adjust your flock size, laying rate, egg selling price and running costs to find out your monthly and yearly profitability.",
  "hens": "Number of laying hens",
  "layRate": "Laying rate (%)",
  "eggPrice": "Egg selling price ($)",
  "feedPerHen": "Feed per hen (g/day)",
  "feedPrice": "Feed price ($/kg)",
  "otherMonthly": "Other monthly costs ($)",
  "resultTitle": "Estimated Profitability",
  "revenue": "Monthly revenue",
  "cost": "Monthly cost",
  "profit": "Monthly profit",
  "profitYear": "Annual profit",
  "margin": "Margin",
  "disclaimer": "Indicative estimate based on your inputs. Does not include equipment depreciation or labor costs.",
  "ctaTitle": "Track your real profitability with Ma Petite Ferme",
  "ctaText": "Log your egg production, costs and sales to manage your chicken coop profitability day by day.",
  "ctaBtn": "Create my farm for free"
 },
 "es": {
  "slug": "calculadora-rentabilidad-gallinero",
  "title": "Calculadora de rentabilidad de un gallinero | Ma Petite Ferme",
  "metaDescription": "Calcula gratis la rentabilidad de tu gallinero: ingresos, costos y ganancia mensual según tus gallinas, la postura y el precio de los huevos.",
  "h1": "Calculadora de rentabilidad de un gallinero",
  "intro": "Estima la ganancia de tu gallinero en pocos segundos. Ajusta el número de gallinas, la tasa de postura, el precio de venta y tus costos para conocer tu rentabilidad mensual y anual.",
  "hens": "Número de gallinas ponedoras",
  "layRate": "Tasa de postura (%)",
  "eggPrice": "Precio de venta por huevo (€)",
  "feedPerHen": "Consumo por gallina (g/día)",
  "feedPrice": "Precio del alimento (€/kg)",
  "otherMonthly": "Otros costos mensuales (€)",
  "resultTitle": "Rentabilidad estimada",
  "revenue": "Ingreso mensual",
  "cost": "Costo mensual",
  "profit": "Ganancia mensual",
  "profitYear": "Ganancia anual",
  "margin": "Margen",
  "disclaimer": "Estimación indicativa basada en tus datos. No incluye la amortización del equipamiento ni la mano de obra.",
  "ctaTitle": "Controla tu rentabilidad real con Ma Petite Ferme",
  "ctaText": "Registra tus posturas, tus costos y tus ventas para gestionar la rentabilidad de tu gallinero día a día.",
  "ctaBtn": "Crear mi granja gratis"
 },
 "it": {
  "slug": "calcolatore-redditivita-pollaio",
  "title": "Calcolatore di redditività di un pollaio | Ma Petite Ferme",
  "metaDescription": "Calcola gratis la redditività del tuo pollaio: ricavi, costi e utile mensile in base al numero di galline, alla deposizione e al prezzo delle uova.",
  "h1": "Calcolatore di redditività di un pollaio",
  "intro": "Stima il guadagno del tuo pollaio in pochi secondi. Regola il numero di galline, il tasso di deposizione, il prezzo di vendita e i tuoi costi per conoscere la tua redditività mensile e annuale.",
  "hens": "Numero di galline ovaiole",
  "layRate": "Tasso di deposizione (%)",
  "eggPrice": "Prezzo di vendita di un uovo (€)",
  "feedPerHen": "Consumo per gallina (g/giorno)",
  "feedPrice": "Prezzo del mangime (€/kg)",
  "otherMonthly": "Altri costi mensili (€)",
  "resultTitle": "Redditività stimata",
  "revenue": "Ricavo mensile",
  "cost": "Costo mensile",
  "profit": "Utile mensile",
  "profitYear": "Utile annuale",
  "margin": "Margine",
  "disclaimer": "Stima indicativa basata sui dati inseriti. Non include l'ammortamento delle attrezzature né il costo della manodopera.",
  "ctaTitle": "Monitora la tua redditività reale con Ma Petite Ferme",
  "ctaText": "Registra le deposizioni, i costi e le vendite per gestire la redditività del tuo pollaio ogni giorno.",
  "ctaBtn": "Crea la mia fattoria gratis"
 },
 "nl": {
  "slug": "rentabiliteit-kippenhok-berekenen",
  "title": "Rentabiliteit kippenhok berekenen | Ma Petite Ferme",
  "metaDescription": "Bereken gratis de rentabiliteit van uw kippenhok: inkomsten, kosten en maandelijkse winst op basis van aantal kippen, legpercentage en eiprijs.",
  "h1": "Rentabiliteit kippenhok berekenen",
  "intro": "Schat de winst van uw kippenhok in enkele seconden. Pas het aantal kippen, het legpercentage, de verkoopprijs en uw kosten aan om uw maandelijkse en jaarlijkse rentabiliteit te kennen.",
  "hens": "Aantal legkippen",
  "layRate": "Legpercentage (%)",
  "eggPrice": "Verkoopprijs per ei (€)",
  "feedPerHen": "Voederverbruik per kip (g/dag)",
  "feedPrice": "Prijs van het voeder (€/kg)",
  "otherMonthly": "Andere maandelijkse kosten (€)",
  "resultTitle": "Geschatte rentabiliteit",
  "revenue": "Maandelijkse inkomsten",
  "cost": "Maandelijkse kosten",
  "profit": "Maandelijkse winst",
  "profitYear": "Jaarlijkse winst",
  "margin": "Marge",
  "disclaimer": "Indicatieve schatting op basis van uw invoer. Bevat geen afschrijving van materiaal noch arbeidskosten.",
  "ctaTitle": "Volg uw werkelijke rentabiliteit met Ma Petite Ferme",
  "ctaText": "Registreer uw legcijfers, kosten en verkopen om de rentabiliteit van uw kippenhok dagelijks op te volgen.",
  "ctaBtn": "Maak mijn boerderij gratis aan"
 },
 "de": {
  "slug": "rentabilitaet-huehnerstall-rechner",
  "title": "Rentabilitätsrechner für Ihren Hühnerstall | Ma Petite Ferme",
  "metaDescription": "Berechnen Sie kostenlos die Rentabilität Ihres Hühnerstalls: Einnahmen, Kosten und monatlicher Gewinn nach Hühnerzahl, Legerate und Eierpreis.",
  "h1": "Rentabilitätsrechner für Ihren Hühnerstall",
  "intro": "Schätzen Sie den Gewinn Ihres Hühnerstalls in wenigen Sekunden. Passen Sie die Anzahl der Hennen, die Legerate, den Verkaufspreis und Ihre Kosten an, um Ihre monatliche und jährliche Rentabilität zu ermitteln.",
  "hens": "Anzahl der Legehennen",
  "layRate": "Legerate (%)",
  "eggPrice": "Verkaufspreis pro Ei (€)",
  "feedPerHen": "Verbrauch pro Henne (g/Tag)",
  "feedPrice": "Futterpreis (€/kg)",
  "otherMonthly": "Sonstige monatliche Kosten (€)",
  "resultTitle": "Geschätzte Rentabilität",
  "revenue": "Monatliche Einnahmen",
  "cost": "Monatliche Kosten",
  "profit": "Monatlicher Gewinn",
  "profitYear": "Jährlicher Gewinn",
  "margin": "Marge",
  "disclaimer": "Richtwert auf Basis Ihrer Eingaben. Enthält weder Abschreibungen für Geräte noch Arbeitskosten.",
  "ctaTitle": "Verfolgen Sie Ihre tatsächliche Rentabilität mit Ma Petite Ferme",
  "ctaText": "Erfassen Sie Ihre Legeleistung, Kosten und Verkäufe, um die Rentabilität Ihres Hühnerstalls täglich im Blick zu behalten.",
  "ctaBtn": "Meinen Hof kostenlos anlegen"
 },
 "sv": {
  "slug": "kalkylator-lsamhet-honseri",
  "title": "Kalkylator för hönserins lönsamhet | Ma Petite Ferme",
  "metaDescription": "Beräkna lönsamheten i ditt hönseri gratis: intäkter, kostnader och månadsvinst utifrån antal hönor, värpning och äggpris.",
  "h1": "Kalkylator för hönserins lönsamhet",
  "intro": "Uppskatta vinsten från ditt hönseri på några sekunder. Justera antal hönor, värpningsgrad, försäljningspris och kostnader för att se din månads- och årsvinst.",
  "hens": "Antal värphönor",
  "layRate": "Värpningsgrad (%)",
  "eggPrice": "Försäljningspris per ägg (kr)",
  "feedPerHen": "Foderförbrukning per höna (g/dag)",
  "feedPrice": "Foderpris (kr/kg)",
  "otherMonthly": "Övriga månadskostnader (kr)",
  "resultTitle": "Beräknad lönsamhet",
  "revenue": "Månadsintäkt",
  "cost": "Månadskostnad",
  "profit": "Månadsvinst",
  "profitYear": "Årsvinst",
  "margin": "Marginal",
  "disclaimer": "Indikativ uppskattning baserad på dina inmatningar. Inkluderar inte avskrivningar på utrustning eller arbetskostnad.",
  "ctaTitle": "Följ din verkliga lönsamhet med Ma Petite Ferme",
  "ctaText": "Registrera dina äggsamlingar, kostnader och försäljningar för att styra hönserins lönsamhet i vardagen.",
  "ctaBtn": "Skapa min gård gratis"
 },
 "da": {
  "slug": "beregner-rentabilitet-honsehus",
  "title": "Beregner til rentabilitet af hønsehus | Ma Petite Ferme",
  "metaDescription": "Beregn gratis rentabiliteten af dit hønsehus: indtægter, omkostninger og månedligt overskud baseret på antal høns, læggefrekvens og ægpris.",
  "h1": "Beregner til rentabilitet af hønsehus",
  "intro": "Estimer overskuddet fra dit hønsehus på få sekunder. Juster antal høns, læggefrekvens, salgspris og dine omkostninger for at kende din månedlige og årlige rentabilitet.",
  "hens": "Antal lægehøns",
  "layRate": "Læggefrekvens (%)",
  "eggPrice": "Salgspris pr. æg (kr.)",
  "feedPerHen": "Forbrug pr. høne (g/dag)",
  "feedPrice": "Foderpris (kr./kg)",
  "otherMonthly": "Andre månedlige omkostninger (kr.)",
  "resultTitle": "Estimeret rentabilitet",
  "revenue": "Månedlig indtægt",
  "cost": "Månedlige omkostninger",
  "profit": "Månedligt overskud",
  "profitYear": "Årligt overskud",
  "margin": "Margin",
  "disclaimer": "Vejledende estimat baseret på dine indtastninger. Inkluderer ikke afskrivning på udstyr eller arbejdstid.",
  "ctaTitle": "Følg din reelle rentabilitet med Ma Petite Ferme",
  "ctaText": "Registrer dine æglægninger, omkostninger og salg for at styre rentabiliteten af dit hønsehus i det daglige.",
  "ctaBtn": "Opret min farm gratis"
 },
 "bg": {
  "slug": "kalkulator-rentabilnost-kokosharna",
  "title": "Калкулатор за рентабилност на кокошарник | Ma Petite Ferme",
  "metaDescription": "Изчислете безплатно рентабилността на вашия кокошарник: приходи, разходи и месечна печалба според броя кокошки, носливостта и цената на яйцата.",
  "h1": "Калкулатор за рентабилност на кокошарник",
  "intro": "Изчислете печалбата от вашия кокошарник за секунди. Задайте броя кокошки, носливостта, продажната цена и разходите, за да разберете месечната и годишната си рентабилност.",
  "hens": "Брой носачки",
  "layRate": "Носливост (%)",
  "eggPrice": "Продажна цена на едно яйце (лв.)",
  "feedPerHen": "Консумация на кокошка (г/ден)",
  "feedPrice": "Цена на фураж (лв./кг)",
  "otherMonthly": "Други месечни разходи (лв.)",
  "resultTitle": "Прогнозна рентабилност",
  "revenue": "Месечен приход",
  "cost": "Месечен разход",
  "profit": "Месечна печалба",
  "profitYear": "Годишна печалба",
  "margin": "Марж",
  "disclaimer": "Приблизителна оценка, базирана на въведените от вас данни. Не включва амортизация на оборудването, нито разходи за труд.",
  "ctaTitle": "Следете реалната си рентабилност с Ma Petite Ferme",
  "ctaText": "Записвайте носливостта, разходите и продажбите си, за да управлявате рентабилността на кокошарника си всеки ден.",
  "ctaBtn": "Създай фермата си безплатно"
 },
 "hr": {
  "slug": "kalkulator-isplativosti-kokosinjca",
  "title": "Kalkulator isplativosti kokošinjca | Ma Petite Ferme",
  "metaDescription": "Besplatno izračunajte isplativost vašeg kokošinjca: prihodi, troškovi i mjesečna dobit prema broju kokoši, nesivosti i cijeni jaja.",
  "h1": "Kalkulator isplativosti kokošinjca",
  "intro": "Procijenite dobit vašeg kokošinjca za nekoliko sekundi. Prilagodite broj kokoši, stopu nesivosti, prodajnu cijenu i troškove kako biste saznali svoju mjesečnu i godišnju isplativost.",
  "hens": "Broj kokoši nesilica",
  "layRate": "Stopa nesivosti (%)",
  "eggPrice": "Prodajna cijena jednog jajeta (€)",
  "feedPerHen": "Potrošnja po kokoši (g/dan)",
  "feedPrice": "Cijena krmiva (€/kg)",
  "otherMonthly": "Ostali mjesečni troškovi (€)",
  "resultTitle": "Procijenjena isplativost",
  "revenue": "Mjesečni prihod",
  "cost": "Mjesečni troškovi",
  "profit": "Mjesečna dobit",
  "profitYear": "Godišnja dobit",
  "margin": "Marža",
  "disclaimer": "Okvirna procjena temeljena na vašim unosima. Ne uključuje amortizaciju opreme ni troškove rada.",
  "ctaTitle": "Pratite svoju stvarnu isplativost uz Ma Petite Ferme",
  "ctaText": "Bilježite nesivost, troškove i prodaju kako biste svakodnevno upravljali isplativošću vašeg kokošinjca.",
  "ctaBtn": "Besplatno kreirajte svoju farmu"
 },
 "et": {
  "slug": "kanala-tasuvuse-kalkulaator",
  "title": "Kanala tasuvuse kalkulaator | Ma Petite Ferme",
  "metaDescription": "Arvuta tasuta oma kanala tasuvus: igakuised tulud, kulud ja kasum munade arvu, munemismäära ja munahinna alusel.",
  "h1": "Kanala tasuvuse kalkulaator",
  "intro": "Hinnake oma kanala kasumit mõne sekundiga. Kohandage kanadе arvu, munemismäära, müügihinda ja kulusid, et teada saada oma igakuine ja aastane tasuvus.",
  "hens": "Munevate kanade arv",
  "layRate": "Munemismäär (%)",
  "eggPrice": "Muna müügihind (€)",
  "feedPerHen": "Söödakulu kana kohta (g/päev)",
  "feedPrice": "Sööda hind (€/kg)",
  "otherMonthly": "Muud igakuised kulud (€)",
  "resultTitle": "Hinnanguline tasuvus",
  "revenue": "Igakuine tulu",
  "cost": "Igakuine kulu",
  "profit": "Igakuine kasum",
  "profitYear": "Aastane kasum",
  "margin": "Kasumimarginaal",
  "disclaimer": "Soovituslik hinnang teie sisestuste põhjal. Ei sisalda seadmete amortisatsiooni ega tööjõukulusid.",
  "ctaTitle": "Jälgige oma tegelikku tasuvust Ma Petite Ferme abil",
  "ctaText": "Salvestage oma munemisandmed, kulud ja müük, et juhtida oma kanala tasuvust igapäevaselt.",
  "ctaBtn": "Loo oma talu tasuta"
 },
 "el": {
  "slug": "ypologistis-apostolis-kotetsiou",
  "title": "Υπολογιστής αποδοτικότητας κοτετσιού | Ma Petite Ferme",
  "metaDescription": "Υπολογίστε δωρεάν την αποδοτικότητα του κοτετσιού σας: έσοδα, κόστη και μηνιαίο κέρδος ανάλογα με τις κότες, την ωοτοκία και την τιμή πώλησης αυγών.",
  "h1": "Υπολογιστής αποδοτικότητας κοτετσιού",
  "intro": "Εκτιμήστε το κέρδος του κοτετσιού σας σε λίγα δευτερόλεπτα. Ρυθμίστε τον αριθμό των κοτών, το ποσοστό ωοτοκίας, την τιμή πώλησης και τα κόστη σας για να μάθετε την αποδοτικότητά σας ανά μήνα και ανά έτος.",
  "hens": "Αριθμός ωοτόκων κοτών",
  "layRate": "Ποσοστό ωοτοκίας (%)",
  "eggPrice": "Τιμή πώλησης αυγού (€)",
  "feedPerHen": "Κατανάλωση ανά κότα (g/ημέρα)",
  "feedPrice": "Τιμή ζωοτροφής (€/kg)",
  "otherMonthly": "Άλλα μηνιαία κόστη (€)",
  "resultTitle": "Εκτιμώμενη αποδοτικότητα",
  "revenue": "Μηνιαία έσοδα",
  "cost": "Μηνιαίο κόστος",
  "profit": "Μηνιαίο κέρδος",
  "profitYear": "Ετήσιο κέρδος",
  "margin": "Περιθώριο κέρδους",
  "disclaimer": "Ενδεικτική εκτίμηση βάσει των στοιχείων που καταχωρήσατε. Δεν περιλαμβάνει την απόσβεση εξοπλισμού ούτε την εργασία.",
  "ctaTitle": "Παρακολουθήστε την πραγματική αποδοτικότητά σας με το Ma Petite Ferme",
  "ctaText": "Καταγράψτε τις ωοτοκίες, τα κόστη και τις πωλήσεις σας για να διαχειρίζεστε το κοτέτσι σας καθημερινά.",
  "ctaBtn": "Δημιουργήστε τη φάρμα μου δωρεάν"
 },
 "fi": {
  "slug": "kananmunatuotannon-kannattavuuslaskuri",
  "title": "Kananmunatuotannon kannattavuuslaskuri | Ma Petite Ferme",
  "metaDescription": "Laske ilmaiseksi kanalaси kannattavuus: kuukausittaiset tuotot, kulut ja voitto munien määrän, munintatahdin ja hinnan mukaan.",
  "h1": "Kanalasi kannattavuuslaskuri",
  "intro": "Arvioi kanalasi tuotto muutamassa sekunnissa. Säädä kanojen määrää, munintaprosenttia, myyntihintaa ja kulujasi laskeaksesi kuukausi- ja vuosikannattavuutesi.",
  "hens": "Munivien kanojen lukumäärä",
  "layRate": "Munintaprosentti (%)",
  "eggPrice": "Munan myyntihinta (€)",
  "feedPerHen": "Rehukulutus kanaa kohti (g/vrk)",
  "feedPrice": "Rehun hinta (€/kg)",
  "otherMonthly": "Muut kuukausikulut (€)",
  "resultTitle": "Arvioitu kannattavuus",
  "revenue": "Kuukausituotto",
  "cost": "Kuukausikulut",
  "profit": "Kuukausittainen voitto",
  "profitYear": "Vuosittainen voitto",
  "margin": "Kate",
  "disclaimer": "Laskelman tulos on suuntaa-antava ja perustuu syöttämiisi tietoihin. Laitehankintoja tai työkustannuksia ei ole huomioitu.",
  "ctaTitle": "Seuraa kanalasi todellista kannattavuutta Ma Petite Ferme -palvelulla",
  "ctaText": "Kirjaa munintasi, kulusi ja myyntisi seurataksesi kanalasi kannattavuutta päivittäin.",
  "ctaBtn": "Luo tilasi ilmaiseksi"
 },
 "hu": {
  "slug": "tyukol-jovedelmezoseg-kalkulator",
  "title": "Tyúkól jövedelmezőségi kalkulátor | Ma Petite Ferme",
  "metaDescription": "Számítsd ki ingyenesen tyúkólad jövedelmezőségét: havi bevétel, költség és haszon a tyúkok száma, tojáshozam és tojásár alapján.",
  "h1": "Tyúkól jövedelmezőségi kalkulátor",
  "intro": "Becsüld meg tyúkólad hasznát néhány másodperc alatt. Állítsd be a tyúkok számát, a tojáshozamot, az eladási árat és a költségeidet, hogy megtudd havi és éves jövedelmezőségedet.",
  "hens": "Tojótyúkok száma",
  "layRate": "Tojáshozam (%)",
  "eggPrice": "Egy tojás eladási ára (Ft)",
  "feedPerHen": "Takarmányfogyasztás tyúkonként (g/nap)",
  "feedPrice": "Takarmány ára (Ft/kg)",
  "otherMonthly": "Egyéb havi költségek (Ft)",
  "resultTitle": "Becsült jövedelmezőség",
  "revenue": "Havi bevétel",
  "cost": "Havi költség",
  "profit": "Havi haszon",
  "profitYear": "Éves haszon",
  "margin": "Haszonkulcs",
  "disclaimer": "Tájékoztató jellegű becslés a megadott adatok alapján. Nem tartalmazza az eszközök amortizációját és a munkaerőköltséget.",
  "ctaTitle": "Kövesd nyomon valós jövedelmezőségedet a Ma Petite Ferme-mel",
  "ctaText": "Rögzítsd tojásaid, költségeid és eladásaid adatait, hogy nap mint nap átláthasd tyúkólad jövedelmezőségét.",
  "ctaBtn": "Farmom létrehozása ingyenesen"
 },
 "pt": {
  "slug": "calculadora-rentabilidade-galinheiro",
  "title": "Calculadora de rentabilidade do galinheiro | Ma Petite Ferme",
  "metaDescription": "Calcule gratuitamente a rentabilidade do seu galinheiro: receitas, custos e lucro mensal pelo numero de galinhas, postura e preco dos ovos.",
  "h1": "Calculadora de rentabilidade do galinheiro",
  "intro": "Estime o lucro do seu galinheiro em poucos segundos. Ajuste o numero de galinhas, a taxa de postura, o preco de venda e os seus custos para conhecer a rentabilidade mensal e anual.",
  "hens": "Numero de galinhas poedeiras",
  "layRate": "Taxa de postura (%)",
  "eggPrice": "Preco de venda de um ovo (R$)",
  "feedPerHen": "Consumo por galinha (g/dia)",
  "feedPrice": "Preco da racao (R$/kg)",
  "otherMonthly": "Outros custos mensais (R$)",
  "resultTitle": "Rentabilidade estimada",
  "revenue": "Receita mensal",
  "cost": "Custo mensal",
  "profit": "Lucro mensal",
  "profitYear": "Lucro anual",
  "margin": "Margem",
  "disclaimer": "Estimativa indicativa baseada nos dados inseridos. Nao inclui a amortizacao dos equipamentos nem a mao de obra.",
  "ctaTitle": "Acompanhe a sua rentabilidade real com a Ma Petite Ferme",
  "ctaText": "Registre as suas posturas, custos e vendas para gerenciar a rentabilidade do seu galinheiro no dia a dia.",
  "ctaBtn": "Criar minha fazenda gratuitamente"
 },
 "pl": {
  "slug": "kalkulator-rentownosci-kurnika",
  "title": "Kalkulator rentowności kurnika | Ma Petite Ferme",
  "metaDescription": "Oblicz bezpłatnie rentowność swojego kurnika: przychody, koszty i miesięczny zysk według liczby kur, nieśności i ceny jaj.",
  "h1": "Kalkulator rentowności kurnika",
  "intro": "Oszacuj zysk z kurnika w kilka sekund. Dostosuj liczbę kur, wskaźnik nieśności, cenę sprzedaży i koszty, aby poznać swoją miesięczną i roczną rentowność.",
  "hens": "Liczba kur niosek",
  "layRate": "Wskaźnik nieśności (%)",
  "eggPrice": "Cena sprzedaży jednego jajka (zł)",
  "feedPerHen": "Zużycie paszy na kurę (g/dzień)",
  "feedPrice": "Cena paszy (zł/kg)",
  "otherMonthly": "Inne koszty miesięczne (zł)",
  "resultTitle": "Szacowana rentowność",
  "revenue": "Miesięczny przychód",
  "cost": "Miesięczny koszt",
  "profit": "Miesięczny zysk",
  "profitYear": "Roczny zysk",
  "margin": "Marża",
  "disclaimer": "Szacunek orientacyjny oparty na wprowadzonych danych. Nie uwzględnia amortyzacji sprzętu ani kosztów pracy.",
  "ctaTitle": "Śledź swoją rzeczywistą rentowność z Ma Petite Ferme",
  "ctaText": "Rejestruj nieśność, koszty i sprzedaż, aby na bieżąco zarządzać rentownością swojego kurnika.",
  "ctaBtn": "Załóż swoją fermę bezpłatnie"
 },
 "lt": {
  "slug": "vistu-ukio-pelningumo-skaiciuokle",
  "title": "Viščiukų ūkio pelningumo skaičiuoklė | Ma Petite Ferme",
  "metaDescription": "Apskaičiuokite savo vištidės pelningumą nemokamai: pajamos, išlaidos ir mėnesinis pelnas pagal vištų skaičių, dėjimą ir kiaušinių kainą.",
  "h1": "Vištidės pelningumo skaičiuoklė",
  "intro": "Įvertinkite savo vištidės pelną per kelias sekundes. Sureguliuokite vištų skaičių, dėjimo intensyvumą, pardavimo kainą ir išlaidas, kad sužinotumėte mėnesinį bei metinį pelningumą.",
  "hens": "Dedeklių vištų skaičius",
  "layRate": "Dėjimo intensyvumas (%)",
  "eggPrice": "Vieno kiaušinio pardavimo kaina (€)",
  "feedPerHen": "Pašarų sąnaudos vienai vištai (g/dieną)",
  "feedPrice": "Pašarų kaina (€/kg)",
  "otherMonthly": "Kitos mėnesinės išlaidos (€)",
  "resultTitle": "Apytikslis pelningumas",
  "revenue": "Mėnesinės pajamos",
  "cost": "Mėnesinės išlaidos",
  "profit": "Mėnesinis pelnas",
  "profitYear": "Metinis pelnas",
  "margin": "Marža",
  "disclaimer": "Apytikslė įvertis pagal jūsų įvestus duomenis. Neapima įrangos nusidėvėjimo ir darbo sąnaudų.",
  "ctaTitle": "Stebėkite savo realų pelningumą su Ma Petite Ferme",
  "ctaText": "Registruokite kiaušinių dėjimą, išlaidas ir pardavimus, kad kasdien valdytumėte savo vištidės pelningumą.",
  "ctaBtn": "Sukurti savo ūkį nemokamai"
 },
 "ro": {
  "slug": "calculator-rentabilitate-cotet-gaini",
  "title": "Calculator rentabilitate coteț găini | Ma Petite Ferme",
  "metaDescription": "Calculează gratuit rentabilitatea cotețului tău: venituri, costuri și profit lunar după numărul de găini, rata de ouat și prețul ouălor.",
  "h1": "Calculator de rentabilitate pentru coteț de găini",
  "intro": "Estimează profitul cotețului tău în câteva secunde. Ajustează numărul de găini, rata de ouat, prețul de vânzare și costurile tale pentru a-ți cunoaște rentabilitatea lunară și anuală.",
  "hens": "Număr de găini ouătoare",
  "layRate": "Rata de ouat (%)",
  "eggPrice": "Prețul de vânzare al unui ou (lei)",
  "feedPerHen": "Consum per găină (g/zi)",
  "feedPrice": "Prețul furajului (lei/kg)",
  "otherMonthly": "Alte costuri lunare (lei)",
  "resultTitle": "Rentabilitate estimată",
  "revenue": "Venit lunar",
  "cost": "Cost lunar",
  "profit": "Profit lunar",
  "profitYear": "Profit anual",
  "margin": "Marjă",
  "disclaimer": "Estimare orientativă bazată pe datele introduse. Nu include amortizarea echipamentelor și nici manopera.",
  "ctaTitle": "Urmărește-ți rentabilitatea reală cu Ma Petite Ferme",
  "ctaText": "Înregistrează ouatul, costurile și vânzările pentru a gestiona rentabilitatea cotețului tău zi de zi.",
  "ctaBtn": "Creează-mi ferma gratuit"
 },
 "lv": {
  "slug": "vistas-nakotnes-rentabilitates-kalkulators",
  "title": "Vistu mājas rentabilitātes kalkulators | Ma Petite Ferme",
  "metaDescription": "Aprēķiniet savas vistu mājas rentabilitāti bez maksas: ieņēmumi, izmaksas un ikmēneša peļņa pēc vistu skaita, dēšanas un olu cenas.",
  "h1": "Vistu mājas rentabilitātes kalkulators",
  "intro": "Aprēķiniet savas vistu mājas peļņu dažu sekunžu laikā. Pielāgojiet vistu skaitu, dēšanas intensitāti, pārdošanas cenu un izmaksas, lai uzzinātu savu ikmēneša un gada rentabilitāti.",
  "hens": "Dējējvistu skaits",
  "layRate": "Dēšanas intensitāte (%)",
  "eggPrice": "Vienas olas pārdošanas cena (€)",
  "feedPerHen": "Barības patēriņš uz vistu (g/dienā)",
  "feedPrice": "Barības cena (€/kg)",
  "otherMonthly": "Citas ikmēneša izmaksas (€)",
  "resultTitle": "Aptuvenie rentabilitātes rādītāji",
  "revenue": "Ikmēneša ieņēmumi",
  "cost": "Ikmēneša izmaksas",
  "profit": "Ikmēneša peļņa",
  "profitYear": "Gada peļņa",
  "margin": "Peļņas marža",
  "disclaimer": "Indikatīvs aprēķins, pamatojoties uz jūsu ievadītajiem datiem. Neietver aprīkojuma nolietojumu un darbaspēka izmaksas.",
  "ctaTitle": "Sekojiet savas vistu mājas reālajai rentabilitātei ar Ma Petite Ferme",
  "ctaText": "Reģistrējiet dēšanas rezultātus, izmaksas un pārdošanu, lai katru dienu kontrolētu savas vistu mājas rentabilitāti.",
  "ctaBtn": "Izveidot savu fermu bez maksas"
 },
 "sk": {
  "slug": "kalkulator-rentabilnosti-kurnika",
  "title": "Kalkulator rentabilnosti kurníka | Ma Petite Ferme",
  "metaDescription": "Vypočítajte si zadarmo rentabilitu vášho kurníka: príjmy, náklady a mesačný zisk podľa počtu sliepok, znášky a ceny vajec.",
  "h1": "Kalkulator rentabilnosti kurníka",
  "intro": "Odhadnite zisk z vášho kurníka za pár sekúnd. Upravte počet sliepok, mieru znášky, predajnú cenu a vaše náklady, aby ste poznali mesačnú a ročnú rentabilitu.",
  "hens": "Počet nosníc",
  "layRate": "Miera znášky (%)",
  "eggPrice": "Predajná cena vajca (€)",
  "feedPerHen": "Spotreba krmiva na sliepku (g/deň)",
  "feedPrice": "Cena krmiva (€/kg)",
  "otherMonthly": "Ostatné mesačné náklady (€)",
  "resultTitle": "Odhadovaná rentabilita",
  "revenue": "Mesačný príjem",
  "cost": "Mesačné náklady",
  "profit": "Mesačný zisk",
  "profitYear": "Ročný zisk",
  "margin": "Marža",
  "disclaimer": "Orientačný odhad na základe zadaných údajov. Nezahŕňa odpisy zariadenia ani náklady na pracovnú silu.",
  "ctaTitle": "Sledujte svoju skutočnú rentabilitu s Ma Petite Ferme",
  "ctaText": "Zaznamenávajte znášky, náklady a predaje, aby ste každý deň mali prehľad o rentabilite vášho kurníka.",
  "ctaBtn": "Vytvoriť moju farmu zadarmo"
 },
 "cs": {
  "slug": "kalkulator-rentability-kurnika",
  "title": "Kalkulátor rentability kurníku | Ma Petite Ferme",
  "metaDescription": "Vypočítejte zdarma rentabilitu vašeho kurníku: příjmy, náklady a měsíční zisk podle počtu slepic, snášky a ceny vajec.",
  "h1": "Kalkulátor rentability kurníku",
  "intro": "Odhadněte zisk z vašeho kurníku za pár sekund. Upravte počet slepic, míru snášky, prodejní cenu a vaše náklady, abyste zjistili měsíční a roční rentabilitu.",
  "hens": "Počet nosnic",
  "layRate": "Míra snášky (%)",
  "eggPrice": "Prodejní cena vejce (Kč)",
  "feedPerHen": "Spotřeba krmiva na slepici (g/den)",
  "feedPrice": "Cena krmiva (Kč/kg)",
  "otherMonthly": "Ostatní měsíční náklady (Kč)",
  "resultTitle": "Odhadovaná rentabilita",
  "revenue": "Měsíční příjem",
  "cost": "Měsíční náklady",
  "profit": "Měsíční zisk",
  "profitYear": "Roční zisk",
  "margin": "Marže",
  "disclaimer": "Orientační odhad na základě zadaných hodnot. Nezahrnuje odpisy vybavení ani náklady na pracovní sílu.",
  "ctaTitle": "Sledujte svou skutečnou rentabilitu s Ma Petite Ferme",
  "ctaText": "Zaznamenávejte snášku, náklady i prodeje a řiďte rentabilitu svého kurníku každý den.",
  "ctaBtn": "Vytvořit mou farmu zdarma"
 },
 "sl": {
  "slug": "kalkulator-donosnosti-kokosnjaka",
  "title": "Kalkulator donosnosti kokošnjaka | Ma Petite Ferme",
  "metaDescription": "Brezplačno izračunajte donosnost vašega kokošnjaka: prihodki, stroški in mesečni dobiček glede na število kokoši, nesnost in ceno jajc.",
  "h1": "Kalkulator donosnosti kokošnjaka",
  "intro": "Ocenite dobiček vašega kokošnjaka v nekaj sekundah. Prilagodite število kokoši, stopnjo nesnosti, prodajno ceno in stroške ter odkrijte svojo mesečno in letno donosnost.",
  "hens": "Število nesnic",
  "layRate": "Stopnja nesnosti (%)",
  "eggPrice": "Prodajna cena jajca (€)",
  "feedPerHen": "Poraba krme na kokoš (g/dan)",
  "feedPrice": "Cena krme (€/kg)",
  "otherMonthly": "Drugi mesečni stroški (€)",
  "resultTitle": "Ocenjena donosnost",
  "revenue": "Mesečni prihodek",
  "cost": "Mesečni stroški",
  "profit": "Mesečni dobiček",
  "profitYear": "Letni dobiček",
  "margin": "Marža",
  "disclaimer": "Okvirna ocena na podlagi vaših vnosov. Ne vključuje amortizacije opreme niti stroškov dela.",
  "ctaTitle": "Spremljajte svojo dejansko donosnost z Ma Petite Ferme",
  "ctaText": "Beležite nesnost, stroške in prodajo ter upravljajte donosnost svojega kokošnjaka vsak dan.",
  "ctaBtn": "Ustvari svojo farmo brezplačno"
 }
};
